module.exports = __webpack_public_path__ + "img/match--type1_img1--sp.f0ca8377.png";